import { createContext } from "react";
var FormContext = createContext({});
export default FormContext;
//# sourceMappingURL=form-context.js.map